// Widget Scripts
import swiperWidget from './js/widgets/swiperWidget.js';
import multiSchedule from './js/widgets/multiSchedule.js';
import seoText from './js/widgets/seoText.js';
import seoCards from './js/widgets/seoCards.js';
import signupWidget from './js/widgets/signupWidget.js';
import instaGridWidget from './js/widgets/instaGridWidget.js';
import sponsorsWidget from './js/widgets/sponsorsWidget.js';
import sponsorsScroller from './js/widgets/sponsorsScroller.js';
import footerGalleryWidget from './js/widgets/footerGalleryWidget.js';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  $(document).ready(function () {
    swiperWidget();
    multiSchedule();
    seoText();
    seoCards();
    signupWidget();
    instaGridWidget();
    sponsorsWidget();
    sponsorsScroller();
  });
}

$(document).ready(function () {
  footerGalleryWidget();
});
